import { Pedido } from '@/models/sit-pedido/pedido'

export interface DocumentoSitPedidos {
  file: File;
  tipoDocumento: String;
  dataEmissao: String;
  dataValidade: String;
  orgaoExpedidor: String;
  numeroComplemento: String;
  filename: String;
  type: String;
  size: String;
  error: Boolean;
  progress: Number;
  uploaded: Boolean;
}

export interface ContactSitPedidos {
  nome: String
  cpf: String
  email: String
  celular: String
  telefone: String
}

export interface FormSitPedidos {
  isLoading: Boolean;
  currentStep: Number;
  pedido: Pedido;
  documents: DocumentoSitPedidos[],
  contact: ContactSitPedidos
}


const formState: FormSitPedidos = {
  isLoading: false,
  currentStep: 1,
  pedido: null,
  documents: null,
  contact: null
}

export default formState
